import React from 'react';
import './Plasticpallet.css';

import Opendeck1 from '../../../imgs/Opendeck1.webp';
import Opendeck2 from '../../../imgs/Opendeck2.webp';
import Opendeck3 from '../../../imgs/Opendeck3.webp';
import Opendeck4 from '../../../imgs/Opendeck4.webp';

const palletData = [
    {
        title: 'Open Deck 9 Feet Light Pallet',
        image: Opendeck1,
        specs: [
            'Dimensions: 1200*1000*145mm',
            'Weight: 7.2 kg',
            'Material: PP',
            'Dynamic Capacity: 0.5 ton',
            'Static Capacity: 1 ton',
            'Machine Model: DP1700',
            'Screw Diameter: 160mm',
        ],
    },
    {
        title: 'Open Deck 9 Feet Pallet',
        image: Opendeck2,
        specs: [
            'Dimensions: 1200*1000*150mm',
            'Weight: 8.5 kg',
            'Material: PE',
            'Dynamic Capacity: 0.5 ton',
            'Static Capacity: 1 ton',
            'Machine Model: DP2000',
            'Screw Diameter: 170mm',
        ],
    },
    {
        title: 'Flat Top 9 Feet Pallet',
        image: Opendeck3,
        specs: [
            'Dimensions: 1200*1000*150mm',
            'Weight: 14.5 kg',
            'Material: PE',
            'Dynamic Capacity: 1 ton',
            'Static Capacity: 1.4 ton',
            'Machine Model: DP2000',
            'Screw Diameter: 170mm',
        ],
    },
    {
        title: 'Flat Double Sided Heavy-duty Pallet',
        image: Opendeck4,
        specs: [
            'Dimensions: 1200*1000*150mm',
            'Weight: 34 kg',
            'Material: PP',
            'Dynamic Capacity: 1.5 ton',
            'Static Capacity: 6 ton',
            'Machine Model: DP3300',
            'Screw Diameter: 240mm',
        ],
    },
];

const Plasticpallet = () => {
    return (
        <div className="pallet-card-container">
            <h2>PLASTIC PALLET MOLDING SOLUTIONS</h2>
            <div className="pallet-cards">
                {palletData.map((pallet, index) => (
                    <div className="pallet-card" key={index}>
                        <img src={pallet.image} alt={pallet.title} />
                        <h3>{pallet.title}</h3>
                        <ul>
                            {pallet.specs.map((spec, i) => (
                                <li key={i}>{spec}</li>
                            ))}
                        </ul>
                        <button className="price-btn">Machine Price</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Plasticpallet;
